import Client from '../../../services/client';

import type { ConfirmPaymentInfo } from '../../../types';

interface ConfirmTaiwanPayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmTaiwanPayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmTaiwanPayTransactionProps) => {
  const { data } = await Client.authApsWalletPay({
    transactionId: confirmPaymentInfo.merchantTransactionId,
    walletType: 'taiwan_pay',
  });

  return data;
};
